import React, { useEffect } from 'react';

const ReportContent = ({ activeReport, isLoading, setIsLoading }) => {
    
    const handleIframeLoad = () => {
        console.log("Iframe chargée :", activeReport?.name);
        setIsLoading(false);
    };

    useEffect(() => {
        if (isLoading) {
            const timer = setTimeout(() => {
                console.warn("Timeout : Forçage de l'arrêt du spinner");
                setIsLoading(false);
            }, 8000); 
            return () => clearTimeout(timer);
        }
    }, [isLoading, setIsLoading]);

    if (!activeReport) {
        return (
            <div className="flex items-center justify-center h-full text-gray-500">
                Sélectionnez un rapport...
            </div>
        );
    }

    return (
        // CHANGEMENT 
        <div className="relative w-full h-full flex flex-col">
            
            {/* TITRE DU RAPPORT (Hauteur fixe, ne grandit pas) */}
            <div className="flex-none mb-4 px-4 pt-2 flex justify-between items-center">
                <h2 className="text-2xl font-bold text-gray-800">{activeReport.name}</h2>
                <div className="text-xs text-gray-400">Source : Power BI</div>
            </div>


            <div className="flex-1 relative w-full bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
                
                {/* SPINNER */}
                {isLoading && (
                    <div className="absolute inset-0 flex items-center justify-center bg-gray-50 z-10">
                        <div className="flex flex-col items-center">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-3"></div>
                            <p className="text-gray-500 font-medium">Chargement...</p>
                        </div>
                    </div>
                )}

                {/* IFRAME */}
                <iframe
                    key={activeReport.id} 
                    title={activeReport.name}
                    src={activeReport.url || activeReport.src}
                    onLoad={handleIframeLoad}
                    className="w-full h-full" 
                    frameBorder="0"
                    allowFullScreen={true}
                />
            </div>
        </div>
    );
};

export default ReportContent;